import React, { useCallback } from 'react'
import { useFieldArray } from 'react-hook-form'
import {
  text,
  button,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { v4 as uuidV4 } from 'uuid'
import { ruleConditions } from './data'

import Condition from '../../Condition'

export default React.memo(
  ({ control, errors, trigger, setValue, conditionMatchTypeName }) => {
    const { fields, append, remove } = useFieldArray({
      control,
      name: 'conditions',
      // default keyName is 'id', which overrides and removes our ids
      // before submit, to prevent that we set it to 'key' and
      // let useFieldArray handles it by itself
      keyName: 'key',
    })

    const onAddCondition = useCallback(
      () => {
        const newCondition = {
          operator: null,
          param: null,
          value: '',
          key: uuidV4(),
        }
        append(newCondition)
      },
      [append]
    )

    const onRemoveCondition = useCallback(
      (condition, index) => {
        remove(index)
      },
      [remove]
    )

    const onConditionChange = useCallback(
      (newCondition, index) => {
        setValue(`conditions.${index}`, newCondition, { shouldDirty: true })
      },
      [setValue]
    )

    const onConditionBlur = useCallback(
      (_condition, index) => {
        trigger(`conditions.${index}`)
      },
      [trigger]
    )

    return (
      <>
        <div>
          {fields.map((item, index) => {
            return (
              <Condition
                control={control}
                name={`conditions.${index}`}
                key={item.key}
                variables={ruleConditions}
                index={index}
                onRemoveCondition={onRemoveCondition}
                totalConditions={fields.length}
                conditionErrorMessage={errors && errors[index]?.message}
                onConditionChange={onConditionChange}
                onBlur={onConditionBlur}
                onInput={onConditionChange}
                decodeIds
                placeholder="Select a condition..."
                conditionMatchTypeName={conditionMatchTypeName}
              />
            )
          })}
        </div>
        <div className="grui mt-10">
          <button
            type="button"
            css={[
              button.styles.link,
              text.styles.textXs,
              text.styles.textPrimary,
            ]}
            onClick={onAddCondition}
          >
            + Add condition
          </button>
        </div>
      </>
    )
  }
)
